import {
  Process,
  ProcessNotificationSetting,
  ProcessDurationScheduledActionType,
} from './../../../../models/process-models';
import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProcessService } from '../../../../services/process.service';
import { EnumDescription } from '../../../../helpers/enum-description.helper';
import { NgxItem } from '../../../../models/common.share.model';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  @Input() process: Process;
  isToggle: boolean = true;
  modalRef: BsModalRef;
  notificationSetting = ProcessNotificationSetting;
  scheduledTypes: Array<NgxItem>;

  constructor(
    private modalService: BsModalService,
    private processService: ProcessService
  ) {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  ngOnInit() {
    this.scheduledTypes = this.mapScheduledTypeToNgxItems();
    if (!this.process.firstDuration.scheduledActions) {
      this.process.firstDuration.scheduledActions = [];
    }
    if (this.process.notificationSettings) {
      return;
    }
    this.process.notificationSettings = [
      ProcessNotificationSetting.NotifyAppraisee,
      ProcessNotificationSetting.NotifyHr,
      ProcessNotificationSetting.NotifyPm,
      ProcessNotificationSetting.NotifyRespondent,
    ];
  }

  toggleSetting(settingItem: number, settingArray: Array<number>) {
    this.processService.toggleEnumSetting(settingArray, settingItem);
  }

  getIsSet(settingItem: number, settingsArray: Array<number>) {
    return settingsArray.indexOf(settingItem) !== -1;
  }

  addScheduledAction() {
    this.process.firstDuration.scheduledActions.push({ offsetDays: 0 });
  }

  removeScheduledAction(scheduledAction) {
    const index = this.process.firstDuration.scheduledActions.indexOf(
      scheduledAction
    );
    this.process.firstDuration.scheduledActions.splice(index, 1);
  }

  private mapScheduledTypeToNgxItems(): Array<NgxItem> {
    const enumKeys = Object.keys(ProcessDurationScheduledActionType).filter(
      (k) => typeof ProcessDurationScheduledActionType[k as any] === 'number'
    );
    return enumKeys.map((x) =>
      Object.assign({
        id: ProcessDurationScheduledActionType[x],
        name: EnumDescription.GetDescription(
          ProcessDurationScheduledActionType,
          ProcessDurationScheduledActionType[x]
        ),
      })
    );
  }
}
